import { gql, MutationFunction } from '@apollo/client';

export const CreateOrganization = gql`
  mutation CreateOrganization(
    $name: String!
    $domains: [String!]!
    $accountId: String!
    $description: String
  ) {
    createOrganization(name: $name, domains: $domains, accountId: $accountId, description: $description)
  }
`;

export type CreateOrganizationMutation = MutationFunction<
  CreateOrganizationData,
  CreateOrganizationVariables
>;
